﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconFileDescription } from "@tabler/icons-react";

export const TiposDocumentoEmpresaHelpText = "* Aquí puede ver toda la lista de los tipos de los documentos que puede tener una empresa.";
export const TiposDocumentoEmpresaIcon = IconFileDescription;


export class catTiposDocumentoEmpresa extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposDocumentoEmpr";
        this.def.columns.c_category_id.defaultValue = "TiposDocumentoEmpr";
        this.Title = "Tipos Documento Empresa";
        this.Icon = TiposDocumentoEmpresaIcon;
        this.HelpText = TiposDocumentoEmpresaHelpText;
    }
}   